import rfdc from 'rfdc';

const simpleClone = rfdc();

/**
 * オブジェクトを参照渡しではなく、クローンして渡す関数
 * @param obj 任意のオブジェクト
 */
export const simpleCopy = function <T>(obj: T) {
  // 巡回していないObject
  return simpleClone(obj);
};
